export default __webpack_public_path__ + "static/kickoff-c8430ce1eed0e57c60773d7e024f7a70.jpg";